<template>
  <b-overlay :variant="skin" :show="loading" rounded="sm">
    <b-row>
      <b-col class="mb-50" cols="12">
        <feather-icon :icon="viewMode ? 'Trash2Icon' : 'EyeOffIcon'" size="18" class="float-right mx-1"
          v-b-tooltip.hover.top="'Exibir Excluídos'" @click="viewMode = !viewMode" />
      </b-col>
      <b-col cols="12">
        <FileUpload icon="VideoIcon" :fileType="fileType.join()" :multiple="true" :viewExcluded="viewMode"
          :listMedias="list" @fileChange="fileChange" @removeMediaItem="removeMediaItem" />
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import { mapMutations } from "vuex";
import { BRow, BCol, BButton, VBTooltip } from "bootstrap-vue";
import AWS from "aws-sdk";
import FileUpload from "@/components/FileUpload.vue";
import _recordingMediaService from "@/services/audiovisual/recording-media";
import _mediaFilesService from "@/services/audiovisual/recording-media-files";
import useAppConfig from "@core/app-config/useAppConfig";
import axios from 'axios'
import _uploadPresignedService from "@/services/upload-presigned-service";

export default {
  setup() {
    const { skin } = useAppConfig();
    return {
      skin,
    };
  },
  components: {
    BRow,
    BCol,
    BButton,
    FileUpload,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    list: {
      handler(newValue, _oldValue) {
        this.$emit("changeItems", newValue);
      },
      deep: true,
    },
    items: {
      handler(newValue, _oldValue) {
        this.list = newValue;
      },
    },
  },
  data() {
    return {
      fileType: [".mp4", ".mov", ".mkv", ".mp3", ".flac", ".wav", ".aac", "mqa", ".m4a"],
      list: [],
      viewMode: true,
    };
  },
  destroyed() {
    this.UPDATE_CURRENT_TOOLBAR("none");
  },
  methods: {
    ...mapMutations({
      UPDATE_VALUE: "toolbar/progress/UPDATE_VALUE",
      UPDATE_CURRENT_TOOLBAR: "toolbar/UPDATE_CURRENT_TOOLBAR",
    }),
    fileChange(files) {
      // VERIFICA A EXTENÇÃO DOS ARQUIVOS
      files.forEach((f) => {
        let ext = f.name.split(".");
        ext = "." + ext[ext.length - 1];
        if (!this.fileType.includes(ext)) {
          f.validate = true;
          this.$utils.toastWarning(
            "Extensão Inválida",
            `A extensão ${ext} não é aceita`
          );
        }
      });

      // VERIFICA SE O ARQUIVO JÁ FOI ADICIONADO
      this.list.forEach((i) => {
        files.forEach((f) => {
          if (f.name == i.name) {
            f.validate = true;
            this.$utils.toastWarning(
              "Arquivo Duplicado",
              `O arquivo '${f.name}' já consta na lista`
            );
          }
        });
      });

      // ADICIONA UM NOVO OBJETO NA LISTA
      if (files) {
        files.forEach((_file) => {
          if (!_file.validate) {
            this.list.push({
              key: this.getKey(_file.name),
              preview: URL.createObjectURL(_file),
              type: _file.type,
              name: _file.name,
              file: _file,
              progress: 0,
              erro: "",
            });
          }
        });
      }

      this.execUpload();
    },
    getKey(name) {
      let key = `${Math.random().toString(16).substr(2)}${Math.random()
        .toString(16)
        .substr(2)}`;
      let ext = name.split(".")[name.split(".").length - 1];
      return `${key}.${ext}`;
    },
    removeMediaItem(item) {
      this.$swal({
        title: item.excluded
          ? "Deseja resgatar esse item da lixeira?"
          : "Deseja remover esse item da lista?",
        text: "-",
        icon: item.excluded ? "warning" : "error",
        showCancelButton: true,
        confirmButtonText: item.excluded
          ? "Sim, quero resgatar!"
          : "Sim, quero remover!",
        cancelButtonText: "Cancelar",
        customClass: {
          confirmButton: "btn btn-info",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          if (item.complete) {
            if (item.uploaded) {
              item.loading = true;
              const payload = [
                {
                  path: "/excluded",
                  op: "replace",
                  value: !item.excluded,
                },
              ];
              _mediaFilesService
                .logicalExclusion(item.recordingMediaFilesID, payload)
                .then((res) => {
                  item.excluded = res.content.excluded;
                })
                .catch((error) => this.$utils.toastError("Notificação", error))
                .finally(() => (item.loading = false));
            } else {
              this.list = this.list.filter((f) => f.key !== item.key);
            }
          } else {
            this.$utils.toastWarning(
              "Envio em Progresso",
              "Pedimos, por favor, que aguarde e tente novamente"
            );
          }
        }
      });
    },
    deleteFileS3(_request) {
      var bucketInstance = new AWS.S3();
      var params = {
        Bucket: _request[0].bucket,
        Key: _request[0].key,
      };
      bucketInstance.deleteObject(params, function (err, data) {
        // if (data) {
        //   console.log("File deleted successfully");
        // } else {
        //   console.log("Check if you have sufficient permissions : " + err);
        // }
      });
    },
    async execUpload() {
      for (let index = 0; index < this.list.length; index++) {
        if (!this.list[index].complete && this.list[index].progress == 0) {
          this.list[index].erro = "";
          const Req = this.list[index];

          const { upload_id } = await _uploadPresignedService.getPresignedVideoUploadID({ key: Req.key })

          const payload = {
            upload_id: upload_id,
            type: 'application/x-www-form-urlencoded',
            file: Req.file,
            key: Req.key
          }

          await this.uploadFileToS3(payload)
        }
      }
    },
    uploadProgress() {
      const inUpload = this.list.filter((f) => !f.inCloud);
      const qtdUpload = inUpload.length;
      let loaded = 0;

      inUpload.forEach((f) => {
        loaded += f.progress;
      });
      this.UPDATE_CURRENT_TOOLBAR("progress-bar");
      this.UPDATE_VALUE(Math.round(loaded / qtdUpload));
    },
    async getPresignedURL(payload) {
      return await _uploadPresignedService.getPresignedVideoURL(payload)
    },
    async uploadFileToS3(payload) {
      try {
        const chunkSize = 5 * 1024 * 1024; // 5 MB
        const chunks = this.splitFile(payload.file, chunkSize);

        // Limite de 5 requisições simultâneas
        const concurrencyLimit = 5;

        // Função para obter o presigned URL e fazer o upload de um chunk
        const uploadChunk = async (i) => {
          const partNumber = i + 1;  // O número da parte deve ser sequencial
          const chunk = chunks[i];

          const { presigned_url } = await this.getPresignedURL({
            uploadId: payload.upload_id,
            contentType: payload.type,
            partNumber: partNumber,
            key: payload.key,
          });

          const response = await this.execPutFileToS3(presigned_url, chunk);

          const eTag = response.headers.etag.replace("\"", "").replace("\"", "");
          return { PartNumber: partNumber, ETag: eTag };
        };

        // Função para controlar o upload com concorrência limitada a 5 requisições simultâneas
        const uploadChunksWithConcurrency = async () => {
          const batchPromises = [];
          const partETags = [];

          // Envia as partes de 5 em 5, mantendo a ordem sequencial
          for (let i = 0; i < chunks.length; i++) {
            // Adiciona a requisição atual na fila
            const uploadPromise = uploadChunk(i).then(result => {
              partETags.push(result);  // Armazena o resultado
            });

            // progress
            let uo = this.list.filter((f) => f.key === payload.key)[0];
            uo.progress = (i / chunks.length) * 100;
            this.uploadProgress();

            // Quando a fila atingir o limite de 5 requisições, aguarda todas as promessas
            batchPromises.push(uploadPromise);
            if (batchPromises.length >= concurrencyLimit) {
              await Promise.all(batchPromises); // Espera terminar 5 requisições antes de continuar
              batchPromises.length = 0;  // Limpa a fila
            }
          }

          // Espera o término de todas as requisições que sobraram na fila
          if (batchPromises.length > 0) {
            await Promise.all(batchPromises);
          }

          return partETags;
        };

        // Executa o upload com concorrência limitada
        const partETagsResults = await uploadChunksWithConcurrency();

        // Chama o serviço para completar o upload
        await _uploadPresignedService.getPresignedVideoComplete({
          uploadId: payload.upload_id,
          key: payload.key,
          partETags: partETagsResults,
        });

        let up = this.list.filter((f) => f.key === payload.key)[0];
        up.complete = true;
        up.progress = 100;
        this.uploadProgress()
      } catch (error) {
        let uo = this.list.filter((f) => f.key === payload.key)[0];
        uo.erro = err;
      }
    },
    async execPutFileToS3(presigned_url, chunk) {
      return await axios.put(presigned_url, chunk)
    },

    splitFile(file, chunkSize = 5 * 1024 * 1024) {
      const chunks = [];
      let start = 0;

      while (start < file.size) {
        const end = Math.min(start + chunkSize, file.size);
        chunks.push(file.slice(start, end));
        start = end;
      }

      return chunks;
    }
  },
};
</script>
